import {Component, Inject, OnInit} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {OrderService} from '../services/order.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {HttpClient} from '@angular/common/http';


@Component({
  selector: 'sms-verification',
  templateUrl: './sms-verification.component.html',
  styleUrls: ['./sms-verification.component.css']
})

export class SmsVerificationComponent implements OnInit {

  _currentLanguage;



  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private formBuilder: FormBuilder,
    private router: Router,

    @Inject(DOCUMENT) private document: Document
  ) {
    translate.onLangChange.subscribe((e: LangChangeEvent) => {

        this._currentLanguage = translate.currentLang;
      }
    );
    this._currentLanguage = translate.currentLang;


  }

  ngOnInit(): void {
  }




  showMessage(msg) {
    this.snackBar.open(msg, null, {
      duration: 5000,
      panelClass: ['app-mat-snack-bar']
    });
  }





}
